/** Messages for the error codes the API returns (e.g. kis-api src/api/admin/error.ts) */
export const ADMIN_ERROR_MESSAGES: Record<string, string> = {
  CLIENT_INTEGRATION_HAS_MEDIA: 'This environment has media. Delete its media in Media Center before deleting it.',
  CLIENT_INTEGRATION_IN_USE_BY_KIOSK:
    'This environment is assigned to one or more kiosks. Assign those kiosks a different environment before deleting it.',
  CONFIGURATION_HAS_MEDIA: 'This configuration has media. Delete its media in Media Center before deleting it.',
  CONFIGURATION_IN_USE_BY_KIOSK:
    'This configuration is assigned to one or more kiosks. Assign those kiosks a different configuration before deleting it.',
  INTEGRATION_IN_USE_BY_CLIENT_INTEGRATION:
    'This integration is used by one or more environments. Delete or change those environments before deleting it.'
};
